/* Páginas legales públicas (B3) y enlaces del pie legal del ingreso. Solo `scope` es local (vite.config.ts); las demás
   clases conservan su nombre. Se registra en styles/scopedOrder.ts, antes de team.css: por eso la columna lleva
   .tm.auth-page.scope (más específica que .tm.auth-page de team.css). Colores solo con tokens del tema (claro y oscuro). */

/* Columna de lectura: el texto corrido se lee mejor en ~70 caracteres (640 px de texto a 14 px). */
.tm.auth-page.scope { max-width: 672px; }

.scope .legal-meta {
  margin: -16px 0 24px;
  color: var(--tm-secondary);
  font-size: 12.5px;
  line-height: 1.5;
}

.scope .legal-meta .tm-link { font-size: inherit; }

.scope .legal-section { margin-top: 24px; }

.scope h2 {
  margin: 0 0 8px;
  color: var(--tm-text);
  font-size: 19px;
  font-weight: 700;
  line-height: 1.3;
}

.scope p,
.scope li {
  color: var(--tm-text);
  font-size: 14px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.scope p { margin: 0 0 8px; }

.scope ul {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0 0 8px;
  padding-inline-start: 20px;
}

@media (max-width: 767px) {
  .scope .legal-meta { margin: -8px 0 16px; }
  .scope h2 { font-size: 17px; }
}

/* Pie legal: la línea del responsable (sin cambios) y debajo los tres documentos. Enlaces subrayados (no solo color) y
   zona de toque de 26 px (≥ 24 px, WCAG 2.2 AA). */
.auth-legal-line { margin: 0; }

/* Mientras llega el código de los enlaces (carga aparte): el alto de su renglón, para que el pie no salte. */
.auth-legal-links-reserva { min-height: 30px; margin-top: 4px; }

.auth-legal-links ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0 16px;
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
}

.auth-legal-links a {
  display: inline-block;
  padding: 4px 2px;
  border-radius: 4px;
  color: inherit;
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.auth-legal-links a:hover { color: var(--text); }

.auth-legal-links a:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring-shadow);
}

/* El documento abierto: sin subrayado y en negrita (no depende solo del color). */
.auth-legal-links a[aria-current="page"] {
  color: var(--text);
  font-weight: 600;
  text-decoration: none;
}
